import { render, staticRenderFns } from "./pj.vue?vue&type=template&id=59c8e9af&scoped=true"
import script from "./pj.vue?vue&type=script&lang=js"
export * from "./pj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8e9af",
  null
  
)

export default component.exports